import { makeStyles } from "@mui/styles";

import theme from "src/theme";
import { MIN_XL_TABLET } from "src/pages/game-new2/constants";

export const useStyles = makeStyles({
    "@global": {
        "@keyframes boxLanguagePeaker": {
            "0%": {
                opacity: 0,
            },
            "100%": {
                opacity: 1,
            },
        },
        "@keyframes boxLanguagePeaker2": {
            "0%": {
                opacity: 0,
            },
            "100%": {
                opacity: 1,
            },
        },
    },
    wrapper: {
        display: "grid",
        gridColumnGap: 83,
        width: "300px",
        gridRowGap: 30,
        justifyContent: "center",
        // gridTemplateColumns: 'repeat(auto-fill, 350px)',
        // justifyContent: 'flex-start',
        margin: "0 auto",
        "&.Sound": {
            width: "250px",
        },
        "&.Profile Settings": {
            width: "150px",
        },
        "&.Apperance": {
            [theme.breakpoints.up("xs")]: {
                gridRowGap: 10,
                gridColumnGap: 35,
            },
            [theme.breakpoints.up(MIN_XL_TABLET)]: {
                gridRowGap: 10,
                gridColumnGap: 35,
                width: "100%",
                height: "400px",
                gridTemplateColumns: "auto auto",
            },
        },
    },
    groupBox: {
        width: "inherit",
        display: "grid",
        gridTemplateColumns: "1fr",
        // gridTemplateRows: 'auto auto auto',
        gridRowGap: 25,
        "&.Apperance": {
            [theme.breakpoints.up(MIN_XL_TABLET)]: {
                width: "150px",
                height: "fit-content",
            },
        },
    },
    settingItemBox: {
        display: "flex",
        gridColumnGap: 30,
        justifyContent: "flex-start",
        cursor: "pointer",
        width: "fit-content",
        [theme.breakpoints.up(MIN_XL_TABLET)]: {
            justifyContent: "space-between",
            flexDirection: "row-reverse",
            alignItems: "center",
            width: "inherit",
        },
    },
    settingItemText: {
        margin: 0,
        padding: 0,
        fontSize: 16,
        fontWeight: 400,
        color: 'rgba(245, 245, 245, 0.9)',
        [theme.breakpoints.up(MIN_XL_TABLET)]: {
            fontSize: 16,
        },
    },

    settingLangItemImg: {
        display: "none",
        [theme.breakpoints.down("lg")]: {
            display: "block",
            width: "25px",
            height: "25px",
        },
    },

    settingItemIcon: {
        [theme.breakpoints.up("xs")]: {
            width: 26,
            height: 26,
            dispay: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        [theme.breakpoints.up(MIN_XL_TABLET)]: {
            width: 26,
            height: 26,
            dispay: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
    },

    boxChangeLanguage: {
        display: "flex",
        width: "100%",
        gridGap: "5px",
        justifyContent: "space-between",
        alignItems: 'center',
    },

    boxLanguagePeaker: {
        opacity: 0,
        animationName: "boxLanguagePeaker",
        animationDelay: "0s",
        animationIterationCount: 1,
        animationFillMode: "forwards",
        animationDuration: "400ms",
        padding: 0,
        display: "flex",
        alignItems: "center",
        marginRight: "-30px",
        [theme.breakpoints.down("lg")]: {
            marginRight: "0px",
            marginTop: "-5px",
        },
    },

    apperanceDemoWrapper: {
        [theme.breakpoints.up("xs")]: {
            width: "276px",
            height: "491px",
            borderRadius: "10px",
            position: "relative",
            margin: "0 auto",
            opacity: 0,
            display: "block",
            "@media screen and (max-height: 720px) and (orientation: portrait)":
                {
                    width: "248px",
                    height: "442px",
                },
            "@media screen and (max-height: 680px) and (orientation: portrait)":
                {
                    width: "207px",
                    height: "369px",
                },
            //"&.darkBlue": {
            //    opacity: 0,
            //    animationName: "boxLanguagePeaker",
            //    animationDelay: "0s",
            //    animationIterationCount: 1,
            //    animationFillMode: "forwards",
            //    animationDuration: "1000ms",
            //    border: "1px solid rgba(0, 100, 200, 0.3)",
            //    background:
            //        "linear-gradient(270deg, #14103C 0%, #080520 50%, #140E5A 100%), linear-gradient(0deg, #2A343D, #2A343D), linear-gradient(270deg, #201B44 0%, #2F287D 52.6%, #201B44 99.99%)",
            //},
            //"&.darkGreen": {
            //    opacity: 0,
            //    animationName: "boxLanguagePeaker2",
            //    animationDelay: "0s",
            //    animationIterationCount: 1,
            //    animationFillMode: "forwards",
            //    animationDuration: "1000ms",
            //    border: "1px solid rgba(138, 104, 233, 0.5)",
            //    background:
            //        "radial-gradient(63.19% 181.28% at 51.57% 62.5%, rgb(0, 73, 78) 0%, rgb(0, 0, 0) 100%)",
            //},
            //"&.darkViolet": {
            //    background:
            //        "linear-gradient(270deg, #1D011A 0%, #24012D 53.65%, rgba(65, 3, 59, 0.97) 100%), #2A343D;",
            //},
            //"&.darkPurple": {
            //    background:
            //        "linear-gradient(270deg, #690835 0%, #16030C 50%, #690835 100%)",
            //},
            //"&.darkGray": {
            //    background:
            //        "linear-gradient(90deg, rgba(60, 68, 83, 0.9875) 0%, #1E2A30 50%, #3C4453 100%), linear-gradient(270deg, #425E07 0%, #243500 48.96%, #425E07 100%)",
            //},
            //"&.deepBlack": {
            //    opacity: 0,
            //    animationName: "boxLanguagePeaker",
            //    animationDelay: "0s",
            //    animationIterationCount: 1,
            //    animationFillMode: "forwards",
            //    animationDuration: "1000ms",
            //    border: "1px solid rgba(0, 100, 200, 0.3)",
            //    background:
            //        "linear-gradient(270deg, #14103C 0%, #080520 50%, #140E5A 100%), linear-gradient(0deg, #2A343D, #2A343D), linear-gradient(270deg, #201B44 0%, #2F287D 52.6%, #201B44 99.99%)",
            //},
        },
        [theme.breakpoints.up(MIN_XL_TABLET)]: {
            width: "455px",
            height: "260px",
            borderRadius: "10px",
            position: "relative",
            //"&.darkBlue": {
            //    opacity: 0,
            //    animationName: "boxLanguagePeaker",
            //    animationDelay: "0s",
            //    animationIterationCount: 1,
            //    animationFillMode: "forwards",
            //    animationDuration: "300ms",
            //    border: "1px solid rgba(0, 100, 200, 0.3)",
            //    background:
            //        "linear-gradient(270deg, #14103C 0%, #080520 50%, #140E5A 100%), linear-gradient(0deg, #2A343D, #2A343D), linear-gradient(270deg, #201B44 0%, #2F287D 52.6%, #201B44 99.99%)",
            //},
            //"&.darkGreen": {
            //    opacity: 0,
            //    animationName: "boxLanguagePeaker2",
            //    animationDelay: "0s",
            //    animationIterationCount: 1,
            //    animationFillMode: "forwards",
            //    animationDuration: "300ms",
            //    border: "1px solid rgba(138, 104, 233, 0.5)",
            //    background:
            //        "radial-gradient(63.19% 181.28% at 51.57% 62.5%, rgb(0, 73, 78) 0%, rgb(0, 0, 0) 100%)",
            //},
            //"&.darkViolet": {
            //    background:
            //        "linear-gradient(270deg, #1D011A 0%, #24012D 53.65%, rgba(65, 3, 59, 0.97) 100%), #2A343D;",
            //},
            //"&.darkPurple": {
            //    background:
            //        "linear-gradient(270deg, #690835 0%, #16030C 50%, #690835 100%)",
            //},
            //"&.darkGray": {
            //    background:
            //        "linear-gradient(90deg, rgba(60, 68, 83, 0.9875) 0%, #1E2A30 50%, #3C4453 100%), linear-gradient(270deg, #425E07 0%, #243500 48.96%, #425E07 100%)",
            //},
            //"&.deepBlack": {
            //    opacity: 0,
            //    animationName: "boxLanguagePeaker",
            //    animationDelay: "0s",
            //    animationIterationCount: 1,
            //    animationFillMode: "forwards",
            //    animationDuration: "300ms",
            //    border: "1px solid rgba(0, 100, 200, 0.3)",
            //    background:
            //        "linear-gradient(270deg, #14103C 0%, #080520 50%, #140E5A 100%), linear-gradient(0deg, #2A343D, #2A343D), linear-gradient(270deg, #201B44 0%, #2F287D 52.6%, #201B44 99.99%)",
            //},
        },
    },

    demoExampleImage: {
        [theme.breakpoints.up("xs")]: {
            borderRadius: "10px",
            objectFit: "contain",
            width: "100%",
            height: "100%",
            //"&.darkBlue": {
            //    background:
            //        "linear-gradient(270deg, #14103C 0%, #080520 50%, #140E5A 100%), linear-gradient(0deg, #2A343D, #2A343D), linear-gradient(270deg, #201B44 0%, #2F287D 52.6%, #201B44 99.99%)",
            //},
            //"&.darkGreen": {
            //    background:
            //        "radial-gradient(63.19% 181.28% at 51.57% 62.5%, rgb(0, 73, 78) 0%, rgb(0, 0, 0) 100%)",
            //},
            //"&.darkViolet": {
            //    background:
            //        "linear-gradient(270deg, #1D011A 0%, #24012D 53.65%, rgba(65, 3, 59, 0.97) 100%), #2A343D;",
            //},
            //"&.darkPurple": {
            //    background:
            //        "linear-gradient(270deg, #690835 0%, #16030C 50%, #690835 100%)",
            //},
            //"&.darkGray": {
            //    background:
            //        "linear-gradient(90deg, rgba(60, 68, 83, 0.9875) 0%, #1E2A30 50%, #3C4453 100%), linear-gradient(270deg, #425E07 0%, #243500 48.96%, #425E07 100%)",
            //},
            //"&.deepBlack": {
            //    background:
            //        "linear-gradient(270deg, #14103C 0%, #080520 50%, #140E5A 100%), linear-gradient(0deg, #2A343D, #2A343D), linear-gradient(270deg, #201B44 0%, #2F287D 52.6%, #201B44 99.99%)",
            //},
        },
        [theme.breakpoints.up(MIN_XL_TABLET)]: {
            borderRadius: "10px",
            objectFit: "contain",
            width: "100%",
            height: "100%",
            //"&.darkBlue": {
            //    background:
            //        "linear-gradient(270deg, #14103C 0%, #080520 50%, #140E5A 100%), linear-gradient(0deg, #2A343D, #2A343D), linear-gradient(270deg, #201B44 0%, #2F287D 52.6%, #201B44 99.99%)",
            //},
            //"&.darkGreen": {
            //    background:
            //        "radial-gradient(63.19% 181.28% at 51.57% 62.5%, rgb(0, 73, 78) 0%, rgb(0, 0, 0) 100%)",
            //},
            //"&.darkViolet": {
            //    background:
            //        "linear-gradient(270deg, #1D011A 0%, #24012D 53.65%, rgba(65, 3, 59, 0.97) 100%), #2A343D;",
            //},
            //"&.darkPurple": {
            //    background:
            //        "linear-gradient(270deg, #690835 0%, #16030C 50%, #690835 100%)",
            //},
            //"&.darkGray": {
            //    background:
            //        "linear-gradient(90deg, rgba(60, 68, 83, 0.9875) 0%, #1E2A30 50%, #3C4453 100%), linear-gradient(270deg, #425E07 0%, #243500 48.96%, #425E07 100%)",
            //},
            //"&.deepBlack": {
            //    background:
            //        "linear-gradient(270deg, #14103C 0%, #080520 50%, #140E5A 100%), linear-gradient(0deg, #2A343D, #2A343D), linear-gradient(270deg, #201B44 0%, #2F287D 52.6%, #201B44 99.99%)",
            //},
        },
    },

    demoAdvanceLinearGradient: {
        [theme.breakpoints.up("xs")]: {
            position: "absolute",
            top: "50%",
            left: "50%",
            zIndex: -2,
            opacity: 1,
            background:
                "radial-gradient(49.98% 49.98% at 49.98% 49.98%, #73f2ff 0%, rgba(82, 163, 255, 0.38) 100%)",
            filter: "blur(20px)",
            borderRadius: "50%",
            transform: "translate(-50%, -50%)",
            width: "290px",
            height: "500px",
        },
        "@media screen and (max-height: 720px) and (orientation: portrait)": {
            width: "260px",
            height: "455px",
        },
        "@media screen and (max-height: 680px) and (orientation: portrait)": {
            width: "220px",
            height: "385px",
        },
        [theme.breakpoints.up(MIN_XL_TABLET)]: {
            position: "absolute",
            top: "50%",
            left: "50%",
            zIndex: -2,
            opacity: 1,
            background:
                "radial-gradient(49.98% 49.98% at 49.98% 49.98%, #73f2ff 0%, rgba(82, 163, 255, 0.38) 100%)",
            filter: "blur(20px)",
            borderRadius: "50%",
            transform: "translate(-50%, -50%) scale(1.1)",
            width: "inherit",
            height: "inherit",
        },
        //"&.darkBlue": {
        //    mixBlendMode: "color-dodge",
        //    background:
        //        "radial-gradient(63.19% 181.28% at 51.57% 62.5%, rgba(214, 226, 235, 0.77) 0%, rgb(0, 0, 0) 100%)",
        //},
        //"&.darkGreen": {
        //    mixBlendMode: "color-dodge",
        //    background:
        //        "radial-gradient(63.19% 181.28% at 51.57% 62.5%, rgb(107, 209, 181) 0%, rgb(0, 0, 0) 100%)",
        //},
        //"&.darkViolet": {
        //    mixBlendMode: "color-dodge",
        //    background:
        //        "linear-gradient(270deg, #1D011A 0%, #24012D 53.65%, rgba(65, 3, 59, 0.97) 100%), #2A343D;",
        //},
        //"&.darkPurple": {
        //    mixBlendMode: "color-dodge",
        //    background:
        //        "linear-gradient(270deg, #690835 0%, #16030C 50%, #690835 100%)",
        //},
        //"&.darkGray": {
        //    mixBlendMode: "color-dodge",
        //    background:
        //        "linear-gradient(90deg, rgba(60, 68, 83, 0.9875) 0%, #1E2A30 50%, #3C4453 100%), linear-gradient(270deg, #425E07 0%, #243500 48.96%, #425E07 100%)",
        //},
        //"&.deepBlack": {
        //    mixBlendMode: "color-dodge",
        //    background:
        //        "radial-gradient(63.19% 181.28% at 51.57% 62.5%, rgba(214, 226, 235, 0.77) 0%, rgb(0, 0, 0) 100%)",
        //},
    },
});
